import { Box } from "@mui/material";
import React from "react";

const COMPANY_NAME = "株式会社LOGEX";
const APP_NAME = "ラクロジ";
const LAST_UPDATED = "2025-10-22";
// 準拠法・管轄は適宜変更してください
const GOVERNING_LAW = "日本法";
const COURT = "横浜地方裁判所";

const Terms: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100vw", // 全画面幅
        height: "100vh", // 全画面高さ
        overflow: "auto", // 外側でスクロールを制御
        paddingLeft: "10px",
      }}
    >
      <main className="mx-auto max-w-3xl px-5 py-10 leading-7 text-gray-900">
        <header className="mb-8">
          <h1 className="text-3xl font-bold">
            エンドユーザー使用許諾契約書（EULA）
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            最終更新日：{LAST_UPDATED}
          </p>
        </header>

        <section className="space-y-6">
          <p>
            本エンドユーザー使用許諾契約書（以下「本契約」）は、{COMPANY_NAME}
            （以下「当社」）が提供する「{APP_NAME}
            」（以下「本アプリ」）の利用条件を定めるものです。ユーザーは本アプリを利用することで、本契約に同意したものとみなされます。
          </p>

          <section>
            <h2 className="mb-2 text-xl font-semibold">第1条（利用許諾）</h2>
            <p>
              当社は、ユーザーに対し、本契約の条件に従って本アプリを利用する非独占的かつ譲渡不能な利用権を付与します。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">
              第2条（アカウント管理）
            </h2>
            <p>
              ユーザーは、認証情報およびアカウントを自己の責任で管理するものとし、不正利用が判明した場合は直ちに当社に通知するものとします。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">第3条（禁止事項）</h2>
            <ul className="list-disc pl-6">
              <li>本アプリの改変、リバースエンジニアリング、複製、再配布</li>
              <li>第三者の権利を侵害する行為</li>
              <li>Amazon等の利用規約に違反する行為</li>
              <li>不正アクセス、セキュリティ侵害に関わる行為</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">第4条（知的財産権）</h2>
            <p>
              本アプリおよび関連資料に関する著作権その他の知的財産権は、当社または正当な権利者に帰属します。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">
              第5条（サービス内容の変更・停止）
            </h2>
            <p>
              当社は、ユーザーへの事前通知の有無にかかわらず、本アプリの全部または一部を変更・中断・終了することがあります。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">第6条（免責）</h2>
            <p>
              当社は、本アプリの利用により生じたいかなる損害についても一切の責任を負いません。当社は本アプリに関し、完全性、正確性、有用性等についていかなる保証も行いません。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">
              第7条（利用停止・契約解除）
            </h2>
            <p>
              当社は、ユーザーが本契約に違反した場合、事前の通知なく本アプリの利用停止または契約解除を行うことができます。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">第8条（契約の変更）</h2>
            <p>
              当社は、必要に応じて本契約の内容を変更できます。変更後の内容は、当社ウェブサイトに掲示した時点から効力を生じます。
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-xl font-semibold">
              第9条（準拠法・合意管轄）
            </h2>
            <p>
              本契約は{GOVERNING_LAW}に準拠し、{COURT}
              を第一審の専属的合意管轄裁判所とします。
            </p>
          </section>

          <p className="text-sm text-gray-700">以上</p>
        </section>
      </main>
    </Box>
  );
};

export default Terms;
